



















import { defineComponent } from 'vue';
import { useWeeklyOverview, type WeeklyOverviewActivity } from '../../composables/presence/useWeeklyOverview';

export default defineComponent({
  props: {
    activity: {
      type: Object as () => WeeklyOverviewActivity,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { startTime, endTime, startLabel, endLabel, preposition, hasSpecified } = useWeeklyOverview(props.activity);

    return {
      startTime,
      endTime,
      startLabel,
      endLabel,
      preposition,
      hasSpecified,
    };
  },
});
